import { composeFieldPath } from '@northfork/basics'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const initialLoadField = composeFieldPath([] as any[])
